export const DAYS_OF_WEEK = {
  SUNDAY: "Domingo",
  MONDAY: "Lunes",
  TUESDAY: "Martes",
  WEDNESDAY: "Miércoles",
  THURSDAY: "Jueves",
  FRIDAY: "Viernes",
  SATURDAY: "Sábado",
};

export const STRINGS = {
  PASSWORD: "Contraseña",
  USERNAME: "Usuario (email)",
  PASSWORD_RECOVERY: "Recuperar contraseña",
  REGISTER: "Registrarse",
  ENTER: "Ingresar",
  TITLE_PLATFORM: "GESTIÓN DE OBRAS PARTICULARES",
  MY_PROCEDURE: "Mis trámites",
  START_PROCEDURE: "Iniciar trámite",
  NOTIFICATIONS: "Notificaciones",
  LOGOUT: "Cerrar sesión",
  CASES: "Expedientes",
  USERS: "Usuarios",
  HOMO: "Homologar",
  REQUIREMENTS: "Requerimientos",
  OFFICES: "Oficinas"
};
